export class FileEntry {
    public timestamp: number;
    public fileName: string;
    public encryptedContent: string;
    public mimeType: string;
    /**
     * content is obsolete and should be discarded in some future after ~mid 2025
     *
     * @deprecated
     */
    public content?: Blob;
}
